export default __webpack_public_path__ + "b94f1ad99e642b2cae94ba1654260707.svg";